import { createSelector } from '@reduxjs/toolkit';
import { getCurrentUserEmail } from '../session';
import { getEmployees } from './get-employees';
import { _sortByValue } from '../utilities/_sortByValue';
import { isCurrentUser } from '../utilities/isCurrentUser';
import { getContactsWithAccessForAccessControl } from '../partners/get-contacts-with-access-for-access-control';

export const getPeopleForAccessControl = createSelector(
  getEmployees,
  getCurrentUserEmail,
  getContactsWithAccessForAccessControl,
  (employees, currentUserEmail, contacts) => {
    const employeeOptions = employees
      .filter((e) => !e.deleted)
      .filter((e) => e.isConfirmedEntity)
      .filter((e) => e.status !== 'TERMINATED')
      .map((e) => ({
        id: e.uuid,
        value: e.firstName + ' ' + e.lastName,
        disabled: isCurrentUser(e.email, currentUserEmail),
      }))
      .sort(_sortByValue);

    const contactOptions = contacts.map((c) => ({
      id: c.id,
      value: c.value,
      disabled: c.disabled,
    }));

    return [...employeeOptions, ...contactOptions];
  },
);
